import type { Routes } from 'react-resource-router';
import { Home } from '@atlassian/twg-microsite-experience';

const homeRoute = {
	name: 'HOME',
	path: '/',
	exact: true,
	component: Home,
} as const;

export const routes: Routes = [homeRoute] as const;
